export default "__VITE_ASSET__5e33c250__"